import React, { useEffect, useState } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableContainer from "@mui/material/TableContainer";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import ReservationStatusChip from "./ReservationStatusChip";
import ReservationStatusDialog from "./ReservationStatusDialog";

export default function ReservationTable(props){

    const [reservations,setReservations] = useState(null)
    const [currentReservation,setCurrentReservation] = useState(null)
    const [showDialog,setShowDialog] = useState(false)

    useEffect(() => {
        setReservations(props.reservations)
      }, [props]);

    return (
      <Box>
        {currentReservation !== null && (
          <ReservationStatusDialog
            isOpen={showDialog}
            close={() => setShowDialog(false)}
            referenceNumber={currentReservation.referenceNumber}
            onComplete = {()=>{
              setShowDialog(false);
               props.onUpdate();
            }            
            }
          />
        )}

        <Typography variant="h6">Reservations</Typography>
        {reservations !== null && (
          <TableContainer>
            <Table sx={{ minWidth: 650 }}>
              <TableHead>
                <TableRow id="header">
                  <TableCell>Id</TableCell>
                  <TableCell>Reference Number</TableCell>
                  <TableCell>Pickup Date</TableCell>
                  <TableCell>Pickup Location</TableCell>
                  <TableCell>Drop off Date</TableCell>
                  <TableCell>Drop off Location</TableCell>
                  <TableCell>Amount</TableCell>
                  <TableCell>Status</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {reservations.map((reservation) => (
                  <TableRow
                    key={reservation.id}
                    onClick={() => props.onReservationSelect(reservation)}
                  >
                    <TableCell>{reservation.id}</TableCell>
                    <TableCell>{reservation.referenceNumber}</TableCell>
                    <TableCell>{reservation.pickUpDate}</TableCell>
                    <TableCell>{reservation.pickUpLocation}</TableCell>
                    <TableCell>{reservation.dropOffDate}</TableCell>
                    <TableCell>{reservation.dropOffLocation}</TableCell>
                    <TableCell>{reservation.amount}</TableCell>
                    <TableCell>
                      <ReservationStatusChip
                        status={reservation.status}
                        onClick={() => {
                          if(reservation.status === "PENDING"){
                          setCurrentReservation(reservation);
                          setShowDialog(true);
                          }
                        }}
                      />
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </Box>
    );


}